import { render, staticRenderFns } from "./classesYears.vue?vue&type=template&id=f764437e&scoped=true&"
import script from "./classesYears.vue?vue&type=script&lang=js&"
export * from "./classesYears.vue?vue&type=script&lang=js&"
import style0 from "./classesYears.vue?vue&type=style&index=0&id=f764437e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f764437e",
  null
  
)

export default component.exports